export class Module {

  constructor(
    public id: number,
    public title: string
  ) {
  }
}
